export default "https://lightningbookassetsdev.blob.core.windows.net/lightning-ui/1.46.0/ui/c4b06f7884e9f54c.gif"